"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PICTURE_ACTIONS = exports.PICTURE_SOURCE = exports.PICTURE_TYPE = exports.DetectResultSource = exports.DetectResultStatus = exports.STORAGE_CLASS = void 0;
exports.isListPicture = isListPicture;
var STORAGE_CLASS;
(function (STORAGE_CLASS) {
    STORAGE_CLASS["STANDARD"] = "STANDARD";
    STORAGE_CLASS["NEARLINE"] = "NEARLINE";
    STORAGE_CLASS["COLDLINE"] = "COLDLINE";
    STORAGE_CLASS["ARCHIVE"] = "ARCHIVE";
})(STORAGE_CLASS || (exports.STORAGE_CLASS = STORAGE_CLASS = {}));
var DetectResultStatus;
(function (DetectResultStatus) {
    DetectResultStatus["SUCCESS"] = "SUCCESS";
    DetectResultStatus["ERROR"] = "ERROR";
})(DetectResultStatus || (exports.DetectResultStatus = DetectResultStatus = {}));
var DetectResultSource;
(function (DetectResultSource) {
    DetectResultSource["LOCAL"] = "LOCAL";
    DetectResultSource["REMOTE"] = "REMOTE";
})(DetectResultSource || (exports.DetectResultSource = DetectResultSource = {}));
var PICTURE_TYPE;
(function (PICTURE_TYPE) {
    PICTURE_TYPE["PICTURE"] = "PICTURE";
    PICTURE_TYPE["SIGNATURE"] = "SIGNATURE";
})(PICTURE_TYPE || (exports.PICTURE_TYPE = PICTURE_TYPE = {}));
var PICTURE_SOURCE;
(function (PICTURE_SOURCE) {
    PICTURE_SOURCE["WEB"] = "WEB";
    PICTURE_SOURCE["MOBILE"] = "MOBILE";
})(PICTURE_SOURCE || (exports.PICTURE_SOURCE = PICTURE_SOURCE = {}));
var PICTURE_ACTIONS;
(function (PICTURE_ACTIONS) {
    PICTURE_ACTIONS["UPLOAD_FILE_FOR_ITEM"] = "UPLOAD_FILE_FOR_ITEM";
    PICTURE_ACTIONS["UPLOAD_FILE_FOR_SUBMISSION"] = "UPLOAD_FILE_FOR_SUBMISSION";
})(PICTURE_ACTIONS || (exports.PICTURE_ACTIONS = PICTURE_ACTIONS = {}));
/** @deprecated to remove after FP-8770 */
function isListPicture(picture) {
    return (picture.action === PICTURE_ACTIONS.UPLOAD_FILE_FOR_ITEM);
}
